'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import { getSelectedRowOrColumn } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { addActiveClass, removeActiveClass } from 'InpageEditorUI/lib/dom';
import { getDndAreaElementForNode } from 'layout-dnd-utils/dom/dndAreaDomSelectors';
const mapStateToProps = state => {
  return {
    selectedRowOrColumn: getSelectedRowOrColumn(state)
  };
};

/**
 * @param {Object} props.selectedRowOrColumn (optional)
 */
class LayoutSectionSelectedNodeContainer extends Component {
  componentDidUpdate(prevProps) {
    const {
      selectedRowOrColumn
    } = this.props;
    const previousId = prevProps.selectedRowOrColumn ? prevProps.selectedRowOrColumn.getName() : null;
    const currentId = selectedRowOrColumn ? selectedRowOrColumn.getName() : null;
    if (previousId && previousId !== currentId) {
      const elem = this.getDndAreaElement(prevProps.selectedRowOrColumn);
      removeActiveClass(elem);
    }

    // We exclude Modules in the last clause of the if because highlighting it is
    // handled by WidgetEditor.js
    if (currentId && currentId !== previousId && !(selectedRowOrColumn.isCell() && selectedRowOrColumn.isModule())) {
      const elem = this.getDndAreaElement(selectedRowOrColumn);
      addActiveClass(elem);
    }
  }
  getDndAreaElement(treeNode) {
    return getDndAreaElementForNode(treeNode);
  }
  render() {
    return null;
  }
}
export default connect(mapStateToProps)(LayoutSectionSelectedNodeContainer);